import {Component, Host, h, Prop, Event, EventEmitter} from '@stencil/core';

@Component({
  tag: 'sol-breadcrumbs',
  styleUrl: 'sol-breadcrumbs.scss',
  shadow: true,
})
export class SolBreadcrumbs {
  @Prop() breadcrumbs: any[] = [];

  @Prop() maxBreadcrumbs: number = 0;

  private _copyBreadCrumbs: any[] = [];

  @Event({
    eventName: 'sol-click',
  })
  onClickEmitter?: EventEmitter<any>;

  componentWillRender() {
    if (this.breadcrumbs.length > this.maxBreadcrumbs) {
      const [firstItem, ...rest] = this.breadcrumbs;
      const lastItem = rest.pop();
      this._copyBreadCrumbs.push(firstItem, lastItem);
    } else {
      this._copyBreadCrumbs = this.breadcrumbs;
    }
  }

  private handleOnSolClick(event: any) {
    event.stopPropagation();
    this.onClickEmitter?.emit(event.detail);
  }

  render() {
    return (
      <Host>
        <nav aria-label="Breadcrumb">
          <ol class={'sol-breadcrumb'}>
            {this._copyBreadCrumbs.map((breadcrumb, index) => (
              <sol-breadcrumb
                key={breadcrumb.label}
                label={breadcrumb.label}
                separator={breadcrumb.separator}
                position={index}
                active={breadcrumb.active}
                onSol-click={(e) => this.handleOnSolClick(e)}
              ></sol-breadcrumb>
            ))}
          </ol>
        </nav>
      </Host>
    );
  }
}
